module.exports = __webpack_public_path__ + "static/media/10_William_F@3x.20c0f7ad.jpg";